// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const pageview = (url) => { console.log(url); window.gtag('config', process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS, { page_path: url }) }

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const event = (action, options = {}) => { window.gtag('event', action, options) }